import { createElement, useEffect, useState } from 'react';
import { VerticalBreadcrumb } from './VerticalBreadcrumb';
import { HorizontalBreadcrumb } from './HorizontalBreadcrumb';
import { useResizeObserverRef } from '../../hooks/useResizeObserver';
import { BreadcrumbProps } from '.';

import cn from './Breadcrumb.css.json';
import './Breadcrumb.css';

export const Breadcrumb = function (props: BreadcrumbProps) {
  // Default to auto
  const orientation = props.orientation || 'AUTO';

  // Handle switching between orientations
  const [isVertical, setIsVertical] = useState<boolean>(orientation === 'VERTICAL');

  const [setBreadcrumbRef] = useResizeObserverRef(({ target, contentRect }) => {
    if (target) {
      const vertical =
        orientation === 'VERTICAL' || (orientation === 'AUTO' && contentRect.width <= 400);
      if (vertical !== isVertical) {
        setIsVertical(vertical);
      }
    }
  });

  const BreadCrumbImpl = isVertical ? VerticalBreadcrumb : HorizontalBreadcrumb;

  useEffect(() => {
    setIsVertical(props.orientation === 'VERTICAL');
  }, [props.orientation]);

  return (
    <div className={props.className} style={props.style} ref={setBreadcrumbRef}>
      <nav
        data-testid={props.testId}
        data-landmark-label={props.landmarkLabel}
        className={cn.breadcrumb}
        role={props.role}
        aria-label={props.ariaLabel}
        aria-labelledby={props.ariaLabelledBy}
        aria-describedby={props.ariaDescribedBy}
      >
        <BreadCrumbImpl
          {...props}
          onOpen={props.openCrumb}
          onPress={props.selectCrumb}
          onPressItem={props.selectCrumbValue}
          tokens={props.tokens}
        />
      </nav>
    </div>
  );
};
